import React, { useMemo } from 'react';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import withFetch from '../../../hoc/withFetch';
import withAuthProvider from '../../../hoc/withAuthProvider';
import Heading from '../../heading';
import SpinnerDots from '../../spinner/dots';
import '../mydistricts.scss';
import '../toggle-text.scss';
import useClassifications from './useClassifications';
import ClassificationsTable from './ClassificationsTable';
import EditTakeover from '../edit-takeover';
import { buildTableColumns } from './classificationTableConfig';
import ClassificationEmptyState from './ClassificationEmptyState';

const ClassificationsPage = ({ match, fetch, isAuthenticated, ...props }) => {
    const scenarioId = match?.params?.scenarioId || null;

    const { data: classifications, isLoading } = useClassifications(scenarioId, fetch);
    const columns = useMemo(() => buildTableColumns({
        renderActions: (row) => (
            <EditTakeover
                id={row.classificationId}
                isActive={true}
                createUrl={`/scenario/${row.salesDistrictScenarioId}/classifications/create`}
                listUrl={`/scenario`}
                isDistrictEdit={false}
                editButton="Ändra klassificering"
                confirmText="Vill du ta bort klassificering permanent?"
                deleteHeading="TA BORT KLASSIFICERING"
                deleteButtonText="Ta bort klassificering"
                scenarioId={row.salesDistrictScenarioId}
            />
        )
    }), []);

    if (!isAuthenticated) {
        return null;
    }

    const renderContent = () => {
        if (!classifications || classifications.length === 0) {
            return (
                <ClassificationEmptyState
                    linkComponent={
                        <a
                            href={`/scenario/${match.params.scenarioId ? `${match.params.scenarioId}/` : ''}classifications/create`}
                            className="form__button districts__add"
                        >
                            + Ny klassificering
                        </a>
                    }
                />
            );
        }

        return (
            <ClassificationsTable
                rows={classifications}
                columns={columns}
                scrollable
                afterTable={
                    <a href={`/scenario/${match.params.scenarioId ? `${match.params.scenarioId}/` : ''}classifications/create`} className="form__button districts__add">+ Ny klassificering</a>
                }
            />
        );
    };

    return (
        <div className={classNames({
            'districts__content': true,
            'districts__content--gray': true,
            'districts__content--padding-top': true,
            'districts__content--padding-bottom': true,
            'districts__content--first': true,
            'districts__content--is-loading': isLoading
        })}>
            {!isLoading && (
                <>
                    <Heading heading="Klassificeringar" />
                    <div className="districts__content-fit districts__content-fit--no-padding">
                        {renderContent()}
                    </div>
                </>
            )}
            <SpinnerDots />
        </div>
    );
};

export default withAuthProvider(withFetch(withRouter(ClassificationsPage)));